import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const GPSTrackingService = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">GPS as Service</h1>
                <p className="colorWht">Controll your Fleet from any PC, iOS or Android running device.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/gps-tracking-system.jpg" alt="gps_tracker" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Collaboration, connectivity and communication are the need of the hour for organizations. It is a constant endeavor to improve employee interactivity and create seamless experiences for customers while having real-time engagements with the field force. Mobility is redefining the rules of user experience with anytime, anywhere availability and is now a necessity for future-ready, borderless global enterprise.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside gps-as-service">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/applications" title="Applications">Applications</Link></li>
                  <li><Link to="/enterprise-resource-planning" title="ERP">ERP</Link></li>
                  <li><Link to="/consulting" title="Consulting">Consulting</Link></li>
                  <li><Link to="/mobility" title="Mobility">Mobility</Link></li>
                  <li><Link to="/business-process" title="Business Process">Business Process</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>GPS as Service</h2>
                <p>Controll your Fleet from any PC, iOS or Android running device</p>
                <p>When do You need it?</p>
                <ul>
                  <li>When You want to use GreenOrange GTrackwithout any installation</li>
                  <li>When You want to see ALL applications possibilities (track, reports, driver information etc.) whether You use any PC or iOS/Android running device</li>
                </ul>
                <p>Where is it possible to connect from?</p>
                <ul>
                  <li>Personal Computer</li>
                  <li>Android or iOS operating systems</li>
                </ul>
                <h3>Fuel consumption solutions with GTrack</h3>
                <p>With G53 GTrack application You have following options to monitor fuel consumption:</p>
                <ul>
                  <li>Show fuel level at the moment</li>
                  <li>Show fuel usage per period of time</li>
                  <li>Show average fuel usage</li>
                  <li>Show fuel temperature information</li>
                </ul>
                <p>Available fuel sources:</p>
                <ul>
                  <li>LLS fuel sensor</li>
                  <li>CAN-bus</li>
                  <li>Impulse fuel counter</li>
                  <li>Analog input</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default GPSTrackingService;

